import classNames from 'classnames';
import React from 'react';
import { getUniqueId } from '@udemy/design-system-utils';
import { TrackImpression } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { ExpressiveIcon } from '@udemy/icons-expressive';
import { noop } from '@udemy/shared-utils';
import { PRO_CONTENT_TYPE } from '../constants';
import styles from "./pro-content-card.module.css";
export const ProContentCard = ({
  children,
  ctaLabel,
  ctaUrl,
  iconName,
  onClick,
  onPresented = noop,
  title,
  headingLevel = 'h3',
  type,
  typeLabelContent
}) => {
  const HeadingElement = headingLevel;
  const {
    interpolate,
    gettext
  } = useI18n();
  const typeLabel = PRO_CONTENT_TYPE[type].label(gettext);
  const titleId = getUniqueId('pro-content-title');
  return /*#__PURE__*/React.createElement(TrackImpression, {
    trackFunc: onPresented
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['card-container']
  }, /*#__PURE__*/React.createElement("div", {
    "aria-labelledby": titleId,
    className: styles['pro-content-card']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon-container']
  }, /*#__PURE__*/React.createElement(ExpressiveIcon, {
    name: iconName,
    className: styles['icon']
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.content)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['pro-content-label']
  }, typeLabelContent ? typeLabelContent : /*#__PURE__*/React.createElement("span", null, typeLabel)), /*#__PURE__*/React.createElement(HeadingElement, {
    id: titleId,
    className: styles['title']
  }, title), children && /*#__PURE__*/React.createElement(React.Fragment, null, children), /*#__PURE__*/React.createElement("a", {
    href: ctaUrl,
    onClick: onClick,
    className: classNames(styles['view-cta'], 'ud-link-underline', 'ud-text-bold', 'ud-text-xs')
  }, ctaLabel !== null && ctaLabel !== void 0 ? ctaLabel : interpolate(gettext('View %(typeLabel)s'), {
    typeLabel
  }, true))))));
};
ProContentCard.displayName = 'ProContentCard';
//# sourceMappingURL=pro-content-card.react-component.js.map